import Bookmarks from './bookmarks';

const Dialog = {
	dialog: document.getElementById('map-dialog'),

	/**
	 * @param {string} url - The URL to load in the dialog
	 * @returns {DOM element} The dialog element.
	 */
	load: async function (url) {
		await fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.text();
			})
			.then((response) => {
				this.dialog.innerHTML = response;
				if (document.querySelector('.bookmark-button-container')) {
					Bookmarks.buildButtons();
				}
				this.dialog.show();
			});
		return this.dialog;
	},

	/**
	 * Load a content string
	 * @param {string} content - HTML content to load
	 * @returns {DOM element} The dialog element.
	 */
	loadContent: async function (content) {
		this.dialog.innerHTML = content;
		this.dialog.show();
		return this.dialog;
	},

	close: function () {
		this.dialog.hide();
	},

	addListeners: () => {
		document.addEventListener('sl-show', (e) => {
			if (e.target.tagName === 'SL-DIALOG') {
				e.target.addEventListener('sl-after-hide', Dialog.handleClose);
			}
		});
	},

	handleClose: function (e) {
		if (e.target.tagName === 'SL-DIALOG') {
			e.target.removeEventListener('sl-after-hide', Dialog.handleClose);
			Dialog.close();
			Dialog.resetClass();

			// if there is an open popup, focus its more_button
			if (W.popups.length) {
				setTimeout(() => {
					document.querySelector('[data-key=' + W.popups[0].key + '] .more_button').focus();
				});
			}
		}
	},

	resetClass: function () {
		this.dialog.setAttribute('class', 'uw-dialog');
		this.dialog.style.removeProperty('--width');
	},
};

Dialog.addListeners();

export default Dialog;
